import { Component } from '@angular/core';
import { HeaderComponent } from '../../layout/header/header.component';
import { NavbarComponent } from '../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../services/core/routelinks.service';

@Component({
  selector: 'app-taxes',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent],
  templateUrl: './taxes.component.html',
  styleUrl: './taxes.component.css'
})
export class TaxesComponent {
  links: any[] = [];
  subLinks: any[] = [];
  constructor(private routelinks: RoutelinksService) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksTaxes; // Inicializa la propiedad en ngOnInit
    this.subLinks = this.routelinks.subLinksTaxes; // Inicializa la propiedad en ngOnInit

  }
}
